import React from 'react';
import { getAnpcPublicBase } from '../lib/anpcDefaults';

export function BuiltinAnpcBanners() {
    const base = getAnpcPublicBase();
    return (
        <div className="anpc-banners-footer" data-testid="site-anpc-builtin">
            <a
                href="https://anpc.ro/ce-este-sal/"
                target="_blank"
                rel="noopener noreferrer"
                title="Soluționarea Alternativă a Litigiilor"
            >
                <img src={`${base}/legal-anpc-sal.png`} alt="Sigla SAL - ANPC" width="250" height="50" />
            </a>
            <a
                href="https://ec.europa.eu/consumers/odr"
                target="_blank"
                rel="noopener noreferrer"
                title="Soluționarea Online a Litigiilor"
            >
                <img src={`${base}/legal-anpc-sol.png`} alt="Sigla SOL - Comisia Europeană" width="250" height="50" />
            </a>
        </div>
    );
}
